module.exports = "<div class=\"ui fluid search selection dropdown\" #dropdownRef>\r\n  <input type=\"hidden\" name=\"search\">\r\n  <i class=\"dropdown icon\"></i>\r\n  <div class=\"default text\">{{placeholder}}</div>\r\n  <div class=\"menu\">\r\n    <div class=\"item\" attr.data-value=\"{{item[value]}}\" *ngFor=\"let item of data\">\r\n      {{item[text]}}\r\n    </div>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/A2-utils/drop-down/components/drop-down/drop-down.component.html
// module id = 2324
// module chunks = 66